export default __webpack_public_path__ + "static/media/photo-2-dark.c14706ab.jpg";